/**
 * PhoneNumber entity - domain model for PhoneNumber business entity
 */

export type PhoneNumberStatus = "PENDING" | "ACTIVE" | "REVOKED";

export interface EsimProfile {
  id: string;
  iccid: string;
  activationCode: string;
  smdpPlus: string;
  status: string;
}

export interface PhoneNumber {
  id: string;
  msisdn: string;
  walletId: string;
  walletFriendlyAddress?: string | null;
  userId: string;
  nftId: string | null;
  balance: string;
  currency: string;
  callDst: string;
  smsDst: string;
  status: PhoneNumberStatus;
  activatedAt: Date | null;
  lastBalanceSyncAt: Date | null;
  auctionEndTime: Date | null;
  esimProfile: EsimProfile | null;
  createdAt: Date;
  updatedAt: Date;
}

/**
 * Check if phone number is active and activated
 */
export function isPhoneNumberActive(phoneNumber: PhoneNumber): boolean {
  return phoneNumber.status === "ACTIVE" && phoneNumber.activatedAt !== null;
}

/**
 * Check if phone number has eSIM profile
 */
export function hasEsimProfile(phoneNumber: PhoneNumber): boolean {
  return phoneNumber.esimProfile !== null && phoneNumber.esimProfile.status === "ACTIVE";
}

/**
 * Format phone number for display
 */
export function formatPhoneNumber(msisdn: string): string {
  if (msisdn.length === 11 && msisdn.startsWith("3712222")) {
    const suffix = msisdn.slice(7);
    return `+371 2222 ${suffix}`;
  }
  return msisdn.startsWith("+") ? msisdn : `+${msisdn}`;
}

